/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
import * as React from "react";
import { TextInput, TextInputProps, useTranslate } from "react-admin";
import { NumericFormat, NumericFormatProps } from "react-number-format";

type NumbericFormatCustomPropsType = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
} & Omit<NumericFormatProps, "valueIsNumericString">;

const NumericFormatCustom = React.forwardRef<NumericFormatProps, NumbericFormatCustomPropsType>(
  function NumericFormatCustom(props, ref) {
    const { onChange, name, ...numericFormatInputProps } = props;

    return (
      <NumericFormat
        {...numericFormatInputProps}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
        valueIsNumericString
      />
    );
  },
);

export type NumericFormatInputPropsType = Pick<
  TextInputProps,
  "source" | "label" | "defaultValue" | "validate" | "fullWidth" | "sx" | "helperText" | "disabled"
> &
  Omit<NumericFormatProps, "valueIsNumericString">;

export default function NumericFormatInput(props: NumericFormatInputPropsType) {
  const translate = useTranslate();
  const {
    source,
    label,
    defaultValue,
    validate,
    fullWidth,
    sx,
    helperText,
    readOnly,
    decimalSeparator = translate("numbers.decimalSeparator"),
    thousandSeparator = translate("numbers.thousandSeparator"),
    ...remainingNumericFormatProps
  } = props;

  return (
    <TextInput
      source={source}
      label={label}
      defaultValue={defaultValue}
      validate={validate}
      helperText={helperText}
      readOnly={readOnly}
      InputProps={{
        inputComponent: NumericFormatCustom as any,
        inputProps: { decimalSeparator, thousandSeparator, ...(remainingNumericFormatProps as any) },
      }}
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      sx={sx}
    />
  );
}
